module.exports = __webpack_public_path__ + "static/media/jabra-elite-75t.ede50766.png";